<div class="content" (window:resize)="onResize()">
  <div *ngIf="isScrollable()" class="button left-button pull-left" (click)="scrollLeft()">
    <i class="fa fa-caret-left fa-2x" aria-hidden="true"></i>
  </div>

  <div class="items-wrapper pull-left">
    <div #scrollbar  class="scrolling-wrapper scrolling-wrapper-flexbox">
      <div class="card">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div *ngIf="isScrollable()" class="button right-button pull-left" (click)="scrollRight()">
    <i class="fa fa-caret-right fa-2x" aria-hidden="true"></i>
  </div>
</div>
